<app-form-manager formPlugin="form-feedback" [params]="params" (saveSucceed)="onSaveSucceed($event)"></app-form-manager>
